export default __webpack_public_path__ + "static/media/NavLogoFooter.c56e55fa.png";